import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const EventsList = Loadable(
  lazy(() =>
    import("./EventsList").then(({ EventsList }) => ({
      default: EventsList,
    }))
  )
);

export const eventsRoutes = [
  {
    path: "/events",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.EVENT]}>
        <EventsList />
      </AuthorizedRoute>
    ),
  },
];
